import React, { useEffect, useState } from "react"
import { useAppDispatch } from "hooks"
import { LocationDocumentInterface } from "@type/locations.types"
import Form from "./Form"
import Table from "./Table"
import { getLocationDocumentByLocationId } from "store/Location/Documents/documents.slice"
import DocumentContext from "./documentContext"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"
import { useLocationScheduleDefaults } from "hooks/useScheduleDefaults"

const Documents = () => {
	const dispatch = useAppDispatch()
	useLocationScheduleDefaults()
	const [document, setDocument] = useState<LocationDocumentInterface | undefined>()
	const { selectedLocation = "" } = useSchedulesQueryParams()

	const handleRow = (e: any) => {
		setDocument(e)
	}

	useEffect(() => {
		selectedLocation && dispatch(getLocationDocumentByLocationId(selectedLocation))
		setDocument(undefined)
	}, [selectedLocation])

	return (
		<DocumentContext.Provider value={{ handleRow, document }}>
			<Form />
			<Table />
		</DocumentContext.Provider>
	)
}

export default Documents
